import { render, staticRenderFns } from "./InputUppercase.vue?vue&type=template&id=27d21389&scoped=true&"
import script from "./InputUppercase.vue?vue&type=script&lang=js&"
export * from "./InputUppercase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d21389",
  null
  
)

export default component.exports